import React from "react";

import { Paper } from "@mui/material";

function LeftSectionLayout({
  hasShadow = true,
  padding = "10px",
  children,
  height = "100%",
}) {
  return (
    <Paper
      data-testid="left-section-layout"
      style={{
        borderRadius: "8px",
        width: "100%",
        padding,
        height,
        boxShadow: hasShadow && "0px 0px 8px 0px rgba(51, 116, 185, 0.25)",
        overflowY: "auto",
      }}
      elevation={hasShadow && 0}
    >
      {children}
    </Paper>
  );
}

export default LeftSectionLayout;
